import axios from 'axios';

const API_URL = process.env.VUE_APP_API_URL + 'assessments';

class AssessmentService {
    create(assessment) {
        return axios
            .post(API_URL, {
                title:assessment.title,
                description: assessment.description,
                type: assessment.type,
                isRandom: assessment.isRandom
            });
    }
    update(assessment) {
        return axios.put(API_URL,  {
            id: assessment._id,
            title: assessment.title,
            description: assessment.description,
            type: assessment.type,
            isRandom: assessment.isRandom,
            isSortingByLevel: assessment.isSortingByLevel
        });
    }
    delete(id) {
        return axios.delete(API_URL, {
            data: {id: id}
        })
    }
    all() {
        return axios.get(API_URL);
    }
    one(id) {
        return axios.get(API_URL + '/' + id)
    }
}

export default new AssessmentService();